import { render, staticRenderFns } from "./pipe-newsletter-confirm.vue?vue&type=template&id=77fbc6cf&scoped=true"
import script from "./pipe-newsletter-confirm.vue?vue&type=script&lang=js"
export * from "./pipe-newsletter-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fbc6cf",
  null
  
)

export default component.exports